// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"1f403d3f","453":"03cce309","738":"e41c3fa3","779":"47ab4c84"}[chunkId] + ".chunk.js";
};